import { LegListSortingTypeEnum } from './leg-list-sorting-type-enum';
import { LegListSortingOrderEnum } from './leg-list-sorting-order-enum';

export class LegListSorting {
  constructor(
    public sortingType: LegListSortingTypeEnum = LegListSortingTypeEnum.Departure,
    public sortingOrder: LegListSortingOrderEnum = LegListSortingOrderEnum.Ascending
  ) {}
}
